export class Exchange {
  id: string;
  date: string;
  time: string;
  inv_details: any;
  item_id: string;


  exchange_reason: any;
  from_branch_id: any;
  to_branch_id: any;
  organization_id: any;

  from_date:string;
  to_date:string;

  creation_user: string;
  creation_ip: string;
  created_at: string;

  last_update_user: string;
  last_update_ip: string;
  last_on_behalf_of: string;
  showDeletedOnly: boolean;

  constructor() {

  }
}



// WEBPACK FOOTER //
// ./src/app/views/pro/exchange/exchange.ts